import React, { useState } from 'react';
import css from './NewConfirmModal.module.css';
import { Button } from '@mm/components';
import { ModalContainer } from '../components/ModalContainer/ModalContainer';
import { ModalCloseButton } from '../components/ModalCloseButton/ModalCloseButton';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { InfoCircleFilled } from '@ant-design/icons';
import { INewConfirmModal } from '@mm/state/modules/modalsState/props';
import { MODALS_TYPE } from '@mm/state/modules/modalsState/types';
import classNames from 'classnames';

const NewConfirmModal: React.FC<INewConfirmModal> = ({
  withImage = true,
  image,
  title = '',
  subtitle = '',
  onReject = async () => {},
  onResolve = async () => {},
  rejectButton = {},
  resolveButton = {},
  css: cssProp,
}) => {
  const [busy, setBusy] = useState(false);

  const { closeModal } = useModalActions();

  const close = () => closeModal(MODALS_TYPE.NEW_CONFIRM_MODAL);

  const handleClose = () => {
    close();
    onReject();
  };

  const handleSubmit = async () => {
    setBusy(true);
    try {
      await onResolve(close);
    } finally {
      setBusy(false);
    }
  };

  return (
    <ModalContainer
      className={classNames(css.container, cssProp?.container)}
      onOutsideClick={handleClose}
    >
      <ModalCloseButton onClick={close} />

      <div className={classNames(css.body, cssProp?.body)}>
        {title && (
          <span className={classNames(css.title, cssProp?.title)}>{title}</span>
        )}

        {subtitle && (
          <div className={css.subtitleWrapper}>
            {withImage && (
              <div className={css.figure}>
                {image ? (
                  image
                ) : (
                  <InfoCircleFilled className={css.defaultIcon} />
                )}
              </div>
            )}
            <span className={classNames(css.subtitle, cssProp?.subtitle)}>
              {subtitle}
            </span>
          </div>
        )}
      </div>

      <div className={css.footer}>
        <Button
          onClick={handleClose}
          {...rejectButton}
          color={rejectButton.color || 'link'}
          css={{
            container: classNames(
              css.secondaryButton,
              css.button,
              cssProp?.cancelButton,
            ),
          }}
          disabled={rejectButton.disabled || busy}
        >
          {rejectButton.children || 'Cancel'}
        </Button>
        <Button
          onClick={handleSubmit}
          {...resolveButton}
          css={{ container: classNames(css.primaryButton, css.button) }}
          disabled={resolveButton.disabled || busy}
        >
          {resolveButton.children || 'Confirm'}
        </Button>
      </div>
    </ModalContainer>
  );
};

export default NewConfirmModal;
